import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Breadcrumb Design Guidelines",
  "title": "Breadcrumb",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="breadcrumb" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Indicate the current page's location within a navigational hierarchy that
  automatically adds separators.
      </LeadParagraph>
      <h2>{`Usage`}</h2>
      <p>{`The default breadcrumb component is styled for use on backgrounds `}<strong parentName="p">{`neutral100`}</strong>{` or `}<strong parentName="p">{`neutral200`}</strong>{`. For dark backgrounds you can use the inverse version.`}</p>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "28.57142857142857%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAIAAABM9SnKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA5ElEQVQY033LQW6DMBBAUS7TTTAm2E5KyyZZhDt1gU1IiRQua4I9xTaUVnaaqlKljGbx9DUTfd1nWR5g+S1/Y6T0JKWxdgaYZG/hYzJmltJq7az1GJRzdr4Oru/tNH0aM4IffXs2gzIAVgdo7R1gAXxRoShlVDgDMBpGrcdxdNHucPFbdj84dHf/x2Vf3ux3X3bR+vnEihYRkW4bVpzTzTGhNSvadNvERLDinOWnmAjy8k5f21XG001N8iPNm6f4LUqowKxGhCeUYyYQ4YhwzOqECkQqzESAL5jVcVZ5U4GpWK2rb0q955svs1yzAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/static/d9c31fcf3bfaf2701b0b977b7981b31a/e3189/example-breadcrumbs.png",
            "srcSet": ["/static/d9c31fcf3bfaf2701b0b977b7981b31a/a2ead/example-breadcrumbs.png 259w", "/static/d9c31fcf3bfaf2701b0b977b7981b31a/6b9fd/example-breadcrumbs.png 518w", "/static/d9c31fcf3bfaf2701b0b977b7981b31a/e3189/example-breadcrumbs.png 1035w", "/static/d9c31fcf3bfaf2701b0b977b7981b31a/b1001/example-breadcrumbs.png 1380w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </figure>
      <hr></hr>
      <h2>{`Responsive Behavior`}</h2>
      <p>{`As the viewport gets smaller, the breadcrumb component will simply wrap to as many lines as necessary. Mobile apps do not typically use breadcrumbs, and the same goes for when our Responsive applications are rendered on smaller screens. Therefore it is appropriate to suppress the breadcrumbs at a specified breakpoint, and provide an alternative way of navigating if necessary. A common breakpoint for hiding breadcrumbs is 600px, which covers the majority of small tablets and phones.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "760px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "31.27413127413127%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAIAAABM9SnKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAnElEQVQY06WP2w6DMAxD+f8/3IU7k2iThlGgoS20k0AbYq9YeXGkI9tJvKAkxhhCRMWIrGgGnJ3z4+gEbBZYD3ZZPKCVMCuygNY5H0I44KIc7mlfN0OWa8PcdXx7vItK56VuxeScrWr1TEXzoiwXRHSCAVlIg2qWwN77cXKtMIAst+R1XYyZjBnYTLrviOiofWnzHv67P/v9nLTDHwUuXbrWJ5PHAAAAAElFTkSuQmCC')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/static/a45304f9ea936808e2f0890a3b55aa60/3c051/breadcrumbs-wrap.png",
                  "srcSet": ["/static/a45304f9ea936808e2f0890a3b55aa60/a2ead/breadcrumbs-wrap.png 259w", "/static/a45304f9ea936808e2f0890a3b55aa60/6b9fd/breadcrumbs-wrap.png 518w", "/static/a45304f9ea936808e2f0890a3b55aa60/3c051/breadcrumbs-wrap.png 760w"],
                  "sizes": "(max-width: 760px) 100vw, 760px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
  `}</div>
        </div></div>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      